import { Box, Button, Group, InputLabel, Stack } from "@mantine/core";
import { useMemo, useState } from "react";
import { TimeInput } from "@mantine/dates";
import { useLanguage } from "../../../../../stores/LanguageStore";
import DailySchedule from "./DailySchedule";
import { useFlowStore } from "../../../../../stores/WorkflowStore";

const TimeIntervalSettingsStep = ({ item, node }) => {
  const lang = useLanguage((s) => s.language);
  const updateNodeData = useFlowStore((s) => s.updateNodeData);

  const [timeStart, setTimeStart] = useState(
    node?.data?.["time_start_sending_" + item.value.split("_")[1]] || null
  );
  const [timeStop, setTimeStop] = useState(
    node?.data?.["time_stop_sending_" + item.value.split("_")[1]] || null
  );

  // No changes needed to these handlers
  const handleStartChange = (newValue) => {
    setTimeStart(newValue);
  };
  const handleStopChange = (newValue) => {
    setTimeStop(newValue);
  };

  const handleStartBlur = (e) => {
    let newValue = e.target.value;

    updateNodeData(node.id, {
      ["time_start_sending_" + item.value.split("_")[1]]: newValue,
    });
  };

  const handleStopBlur = (e) => {
    let newValue = e.target.value;

    updateNodeData(node.id, {
      ["time_stop_sending_" + item.value.split("_")[1]]: newValue,
    });
  };

  const active = useMemo(() => {
    return item.value === "allowed_saturday" || item.value === "allowed_sunday"
      ? node?.data?.sending_weekends_allowed
        ? true
        : false
      : true;
  }, [item.value, node?.data?.sending_weekends_allowed]);

  return (
    <Stack key={item.value} align="start" w={"100%"}>
      <Group>
        <Box
          style={{
            border: "1px solid",
            borderRadius: 600,
            borderColor: node?.data?.[item.value]
              ? "var(--mantine-color-primary-4)"
              : "#00000033",
          }}
          p={4}
        >
          <Button
            size={"sm"}
            key={item.value}
            variant={active ? "filled" : "subtle"}
            radius={"xl"}
            w={130}
            style={{ pointerEvents: "none" }}
          >
            {item.label}
          </Button>
        </Box>
        <Group wrap="nowrap">
          <InputLabel size="md">
            {lang.workflows.program.step_config.more.time_start_from}
          </InputLabel>
          <TimeInput
            name={"time_start_sending_" + item.value.split("_")[1]}
            size="sm"
            disabled={!active}
            value={timeStart}
            onChange={(e) => handleStartChange(e.target.value)}
            onBlur={handleStartBlur}
          />
        </Group>
        <Group wrap="nowrap">
          <InputLabel size="md">
            {lang.workflows.program.step_config.more.time_start_to}
          </InputLabel>
          <TimeInput
            name={"time_stop_sending_" + item.value.split("_")[1]}
            size="sm"
            disabled={!active}
            value={timeStop}
            onChange={(e) => handleStopChange(e.target.value)}
            onBlur={handleStopBlur}
          />
        </Group>
      </Group>

      <DailySchedule
        timeStart={timeStart || node?.data?.time_start_sending}
        timeStop={timeStop || node?.data?.time_stop_sending}
        disabled={!active}
      />
    </Stack>
  );
};

export default TimeIntervalSettingsStep;
